<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoEditar">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoEditar">
            <form #f="ngForm" name="form" novalidate>
                <div class="formgroup" >
                    <div class="flex justify-content-center" *ngIf="exibirSpinner">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                    </div>
                </div>
                <div class="formgroup" >
                    <div class="p-fluid p-formgrid grid" *ngIf="consumoFolha && !exibirSpinner">
                        
                        <div class="form-group field col-12 md:col-5">
							<label>Profissional</label>
							<label class="form-control" id="descricao">{{ consumoFolha.nomeProfissional }}</label>
						</div>
                        <div class="field col-12 md:col-5">
                            <label htmlFor="item">Produto/Servico</label>
                            <label class="form-control" id="item" *ngIf="tipoItemSelecionado === 3">{{ itemProdutoSelecionado?.descricao }}</label>
                            <label class="form-control" id="item" *ngIf="tipoItemSelecionado === 4">{{ itemServicoSelecionado?.descricao }}</label>
                        </div>
                        <div class="form-group field col-12 md:col-2">
							<label>Data Transação</label>
							<label class="form-control">{{ consumoFolha.dataTransacao | date:'dd/MM/yyyy' }}</label>
						</div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorItem">Valor de Venda</label>
                            <label class="form-control" id="valorItem">{{ consumoFolha.valorVendaItem | currency:'BRL' }}</label>
                        </div>
                        
                        <div class="form-group field col-12 md:col-2">
							<label>Desconto</label>
							<label class="form-control">{{ consumoFolha.desconto ? (consumoFolha.desconto / 100 | percent:'1.2-2') : '0.0%' }}</label>
						</div>
                        
                        <div class="form-group field col-12 md:col-2">
							<label>Valor a cobrar</label>
							<label class="form-control">{{ consumoFolha.valorACobrar | currency:'BRL' }}</label>
						</div>
                        <div class="form-group field col-12 md:col-2">
							<label>Quantidade</label>
							<label class="form-control">{{ consumoFolha.quantidade }}</label>
						</div>
                        <div class="form-group field col-12 md:col-2">
							<label>Valor Total</label>
							<label class="form-control">{{ consumoFolha.valorTotal | currency:'BRL' }}</label>
						</div>
						
						<div class="form-group field col-12 md:col-2">
							<label>Nº Parcelas</label>
							<label class="form-control" id="operacao">{{ consumoFolha.parcelas }}</label>
						</div>
                        <div class="field col-12 md:col-12">
                            <p-table #dt1 [value]="parcelasConsumo" dataKey="id" [rows]="10" [rowHover]="true"
                                styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
                                styleClass=" p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>
                                            <div>
                                                Descrição
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                Parcela
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                Data a Cobrar
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                Valor
                                            </div>
                                        </th>
                                        <th>
                                            <div>
                                                Excluir
                                            </div>
                                        </th>

                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item let-i="rowIndex">
                                    <tr>
                                        
                                        <td>
                                            <label>{{ item.descricao }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.parcela }}</label>
                                        </td>
                                        <td>
                                            <p-calendar
                                                [readonlyInput]="false"
                                                [showIcon]="true"
                                                dateFormat="dd/mm/yy"
                                                [showButtonBar]="true"
                                                name="dataCompetencia{{i}}" ngModel [(ngModel)]="item.dataCompetencia"
                                                appendTo="body">
                                            </p-calendar>
                                        </td>
                                        
                                        <td>
                                            <label class="form-control">{{ item.valorRegistro | currency:'BRL' }}</label>
                                        </td>
                                        <td>
                                            <button *ngIf="verificarPermissao('PERM_EXCLUIR_ADIANTAMENTO_FOLHA')"
                                                pButton pRipple pTooltip="Excluir" icon="pi pi-trash"
                                                (click)="excluirItemFolha(item.id)"
                                                class="p-button-danger mr-2 mb-2 sm"></button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between" *ngIf="!exibirSpinner">
                        <div class="col-12 md:col-4">
                            <button *ngIf="!progressoRequisicao;else exibirBotaoFalso"
                                type="submit" pButton icon="pi pi-check" label="Atualizar"
                                class="p-button-outlined p-button-success md:w-9rem" [disabled]="!consumoFolha"
                                (click)="atualizar()">
                            </button>
                            <ng-template #exibirBotaoFalso>
                                <button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizar"
                                class="p-button-outlined p-button-success md:w-9rem" disabled>
                                </button>
                            </ng-template>
                        </div>

                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem" routerLink="/apps/consumo"></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog header="Consumo Excluído" [(visible)]="exibirRedirecionar" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true"
                (onHide)="redirecionarListagem()">
                <div class="flex justify-content-between">
                    <p>
                        Você será redirecionado para a listagem
                    </p>
                    <button type="button" pButton label="OK" class="p-button-primary"
                        (click)="redirecionarListagem()"></button>
                </div>
            </p-dialog>
            <p-confirmDialog [style]="{width: '50vw'}">
            </p-confirmDialog>
            <p-dialog header="Adicionar Produto/Serviço" [(visible)]="mostrarDialogItem" [modal]="true"
                [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [closable]="true">
                <div class="card">
                    <div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <p-table #tabelaListaItens [value]="listaItens" dataKey="id" [rows]="10" [rowHover]="true"
                        styleClass="p-datatable-gridlines" [paginator]="true" responsiveLayout="scroll"
                        styleClass=" p-datatable-sm" [globalFilterFields]="['codigo', 'descricao']" *ngIf="!exibirSpinnerDialog">
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between flex-column sm:flex-row">
                                <p-dropdown [options]="tiposItem" optionLabel="label" optionValue="value"
                                    emptyFilterMessage="Nenhum registro" name="situacao" ngModel #situacao="ngModel"
                                    [(ngModel)]="tipoItemSelecionado" (onChange)="carregarItens()">
                                </p-dropdown>
                                <div>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text" #filter (input)="buscar(tabelaListaItens, $event)"
                                            placeholder="Buscar" class="w-full" />
                                    </span>
                                    <span class="ml-2">
                                        <button pButton class="p-button-outlined" icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros" (click)="limpar(tabelaListaItens)"></button>
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="codigo">
                                    <div>
                                        Código
                                    </div>
                                </th>
                                <th pSortableColumn="descricao">
                                    <div>
                                        Descrição
                                    </div>
                                </th>

                                <th style="text-align: center;">
                                    <div>
                                        Selecionar
                                    </div>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item let-i="rowIndex">
                            <tr>
                                <td>
                                    <label>{{ item.codigo }}</label>
                                </td>
                                <td>
                                    <label>{{ item.descricao }}</label>
                                </td>

                                <td style="text-align: center;">
                                    <button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
                                        class="p-button-success" (click)="adicionarItem(item)">
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex align-items-center justify-content-between">
                                Há {{listaItens ? listaItens.length : 0 }} Itens
                                disponíveis.
                            </div>
                        </ng-template>
                    </p-table>

                </div>
                <p-footer>
                    <button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
                        (click)="mostrarDialogItem = false"></button>
                </p-footer>
            </p-dialog>
        </div>
    </div>
</div>